import { GamificationStatus } from '@/@types/gamification';

export type CampaignStatus = GamificationStatus;

export const STATUS_COLORS = {
  [GamificationStatus.ATIVA]: "bg-emerald-100 text-emerald-800 border-emerald-200",
  [GamificationStatus.INATIVA]: "bg-slate-100 text-slate-700 border-slate-200",
  [GamificationStatus.AGENDADA]: "bg-amber-100 text-amber-800 border-amber-200",
  [GamificationStatus.ENCERRADA]: "bg-red-100 text-red-800 border-red-200",
  [GamificationStatus.RASCUNHO]: "bg-violet-100 text-violet-800 border-violet-200",
} as const;

export const STATUS_LABELS = {
  [GamificationStatus.ATIVA]: "Ativa",
  [GamificationStatus.INATIVA]: "Inativa",
  [GamificationStatus.AGENDADA]: "Agendada",
  [GamificationStatus.ENCERRADA]: "Encerrada",
  [GamificationStatus.RASCUNHO]: "Rascunho",
} as const;

export function calculateCampaignStatus(
  startDate: string,
  endDate: string,
  isDeleted: boolean = false
): CampaignStatus {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [startYear, startMonth, startDay] = startDate.split('T')[0].split('-');
  const start = new Date(Number(startYear), Number(startMonth) - 1, Number(startDay));
  start.setHours(0, 0, 0, 0);

  const [endYear, endMonth, endDayFull] = endDate.split('T')[0].split('-');
  const end = new Date(Number(endYear), Number(endMonth) - 1, Number(endDayFull));
  end.setHours(23, 59, 59, 999);

  if (isDeleted) {
    return GamificationStatus.INATIVA;
  }

  if (today < start) {
    return GamificationStatus.AGENDADA;
  }

  if (today > end) {
    return GamificationStatus.ENCERRADA;
  }

  return GamificationStatus.ATIVA;
}

export function isCampaignActive(status: CampaignStatus): boolean {
  return status === GamificationStatus.ATIVA;
}

const EDITABLE_STATUSES: readonly GamificationStatus[] = [
  GamificationStatus.AGENDADA,
  GamificationStatus.ATIVA,
  GamificationStatus.RASCUNHO,
];

export function isCampaignEditable(status: CampaignStatus): boolean {
  return EDITABLE_STATUSES.includes(status);
}

export function getStatusDescription(status: CampaignStatus): string {
  return STATUS_LABELS[status];
}

export function getStatusColor(status: CampaignStatus): string {
  return STATUS_COLORS[status];
}
